import { useEffect } from "react";
import { Box } from "@mui/material";
import Exit from "../../images/exitModal.webp";

export default function ExitModal({ setOpenExitModal, scrollTo }) {
  return (
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: {
          xs: "min(90vw, calc(90vh * 0.75))", // under 600px (extra-small screens)
          sm: "min(60vw, calc(90vh * 0.75))", // 600px and up
          md: "min(30vw, calc(90vh * 0.75))",
        },
        aspectRatio: "3 / 4",
        boxShadow: 24,
        overflow: "hidden",
        backgroundImage: `url(${Exit})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        bgcolor: "#93e3d3",
        cursor: "pointer",
      }}
      onClick={() => {
        setOpenExitModal(false);
        scrollTo();
      }}
    />
  );
}
